// extracted by mini-css-extract-plugin
export default {"wrapper":"sortSelectBox_wrapper__+hidz","popup":"sortSelectBox_popup__lHpL0","displayIcon":"sortSelectBox_displayIcon__f61vB"};